import type { TableFilter } from '@ipfabric/utils';
import { array, option } from 'fp-ts';
import { pipe } from 'fp-ts/lib/function';
import {
  type AllowedOperatorReadable,
  getAllowedOperators,
  getReadableFromOperator,
} from './filterOperators';

export const getOperatorFromFilter = (
  filter: TableFilter,
  value: string | null,
): AllowedOperatorReadable =>
  pipe(
    filter,
    getAllowedOperators,
    array.map(getReadableFromOperator),
    // longer must go first to be matched first, to not e.g. match only > when there is >=
    (arr) => arr.sort((a, b) => b.length - a.length),
    array.findFirst((o) => value?.startsWith(o) ?? false),
    option.getOrElse<AllowedOperatorReadable>(() => ''),
  );
